import { FC, useEffect } from 'react'
import { createPortal } from 'react-dom'
import css from 'classnames'
import { observer } from 'mobx-react-lite'
import { FiX } from 'react-icons/fi'
import { Card } from '..'
import { PropsModalWindow } from './type'
import '../../../app/styles/index.css'

export const ModalWindow: FC<PropsModalWindow> = observer(
  ({
    isOpen,
    onClose,
    maxWidth,
    size,
    title,
    showCloseButton = false,
    children,
  }) => {
    useEffect(() => {
      if (isOpen) {
        document.body.classList.add('no-scroll')
      } else {
        document.body.classList.remove('no-scroll')
      }

      return () => {
        document.body.classList.remove('no-scroll')
      }
    }, [isOpen])

    if (typeof document === 'undefined') {
      return null
    }

    const modalContent = (
      <div
        className={css(
          'fixed left-0 right-0 top-0 z-[9999] items-center justify-center overflow-x-hidden overflow-y-auto md:inset-0',
          size === 'medium'
            ? 'h-[100dvh] p-0 sm:p-4'
            : 'h-[calc(100%-1rem)] max-h-full p-4',
          { flex: isOpen },
          { hidden: !isOpen },
        )}
      >
        <div
          className="fixed right-0 overflow-y-hidden left-0 bottom-0 top-0 bg-black opacity-50 z-[9999]"
          onClick={onClose}
        />

        <div
          className={css('relative z-[9999] max-h-full overflow-y-visible', {
            'h-full w-full max-w-none sm:h-auto sm:w-[calc(100vw-2rem)] sm:max-w-3xl':
              size === 'medium',
            'max-w-[65%]': size === undefined && maxWidth,
            'w-[600px]': size === undefined && !maxWidth,
          })}
        >
          <Card
            className={css({
              'h-full overflow-y-auto rounded-none border-0 sm:h-auto sm:max-h-[calc(100dvh-2rem)] sm:rounded-xl sm:border':
                size === 'medium',
            })}
          >
            {(title || showCloseButton) && (
              <div
                className={css('flex p-2', {
                  'items-start gap-4 border-b border-slate-200 pb-4 sm:p-4 sm:pb-4':
                    size === 'medium',
                  'items-center': size !== 'medium',
                })}
              >
                <div
                  className={css('min-w-0 font-semibold text-gray-800', {
                    'text-2xl text-slate-900': size === 'medium',
                    'text-[18px]': size !== 'medium',
                  })}
                >
                  {title}
                </div>

                {showCloseButton && (
                  <button
                    type="button"
                    aria-label="Закрыть"
                    className="ml-auto rounded-lg p-2 text-slate-400 transition hover:bg-slate-100 hover:text-slate-700"
                    onClick={onClose}
                  >
                    <FiX size={20} />
                  </button>
                )}
              </div>
            )}
            {children}
          </Card>
        </div>
      </div>
    )

    return createPortal(modalContent, document.body)
  },
)
